import { stringLiteralArray } from '@studio/utils/utils';
export const animatableProperties = stringLiteralArray([
    'x',
    'y',
    'originX',
    'originY',
    'rotationX',
    'rotationY',
    'rotationZ',
    'opacity',
    'scaleX',
    'scaleY',
    'fill',
    'radius',
    'shadows',
    'filters',
    'textColor',
    'border'
]);
export const transitionSettingPropertyToUnitMap = {
    direction: 'angle',
    distance: 'number'
};
